import moment from 'moment'
import { citizenshipTypeMap, documentTypeMap, userRoleMap } from '../../../../constants/approval'

export const individualEntrepreneurInfoConfig = (profile: any, nextProfile: any) => [
    {
        name: 'Роль в системе',
        value: userRoleMap.get(profile.user_role),
        blur: !!nextProfile && profile.user_role !== nextProfile.user_role,
    },
    {
        name: 'Тип пользователя',
        value: 'Индивидуальный предприниматель',
        blur: !!nextProfile && profile.user_type !== nextProfile.user_type,
    },
    {
        name: 'ФИО',
        value: `${profile.last_name} ${profile.first_name} ${profile.middle_name}`,
        blur:
            !!nextProfile &&
            (profile.last_name !== nextProfile.last_name ||
                profile.first_name !== nextProfile.first_name ||
                profile.middle_name !== nextProfile.middle_name),
    },
    {
        name: 'Логин',
        value: profile.login,
        blur: !!nextProfile && profile.login !== nextProfile.login,
    },
    {
        name: 'E-mail',
        value: profile.email,
        blur: !!nextProfile && profile.email !== nextProfile.email,
    },
    {
        isDivider: true,
        noMargin: true,
    },
    {
        name: 'Дата рождения',
        value: profile.birthday && moment(profile.birthday).format('DD.MM.YYYY'),
        blur: !!nextProfile && profile.birthday !== nextProfile.birthday,
    },
    {
        name: 'Статус гражданина',
        value: citizenshipTypeMap.get(profile.citizenship_type),
        blur: !!nextProfile && profile.citizenship_type !== nextProfile.citizenship_type,
    },
    {
        name: 'Гражданство',
        value: profile.citizenship,
        blur: !!nextProfile && profile.citizenship !== nextProfile.citizenship,
    },
    {
        name: 'Адрес регистрации',
        value: profile.registration_address,
        blur: !!nextProfile && profile.registration_address !== nextProfile.registration_address,
        noMargin: true,
    },
    {
        name: 'Почтовый адрес',
        value: profile.post_address_matches ? profile.registration_address : profile.post_address,
        blur:
            !!nextProfile &&
            (profile.post_address_matches !== nextProfile.post_address_matches ||
                (profile.post_address_matches &&
                    profile.registration_address !== nextProfile.registration_address) ||
                (!profile.post_address_matches &&
                    profile.post_address !== nextProfile.post_address)),
    },
    {
        name: 'Документ, удостоверяющий личность',
        value: documentTypeMap.get(profile.document_type),
        blur: !!nextProfile && profile.document_type !== nextProfile.document_type,
    },
    {
        name: 'Серия и номер паспорта',
        value:
            profile.document_type === 1
                ? `${profile.passport_series} ${profile.passport_number}`
                : profile.document_custom_number,
        blur:
            !!nextProfile &&
            (profile.document_type !== nextProfile.document_type ||
                profile.passport_series !== nextProfile.passport_series ||
                profile.document_custom_number !== nextProfile.document_custom_number),
    },
    {
        name: 'Дата выдачи паспорта',
        value:
            profile.document_type === 1
                ? profile.passport_date
                : profile.document_custom_betrayed_date,
        blur:
            !!nextProfile &&
            (profile.document_type !== nextProfile.document_type ||
                profile.passport_date !== nextProfile.passport_date ||
                profile.document_custom_betrayed_date !==
                    nextProfile.document_custom_betrayed_date),
    },
    {
        name: 'Кем выдан паспорт',
        value:
            profile.document_type === 1
                ? profile.passport_betrayed_name
                : profile.document_custom_betrayed_name,
        blur:
            !!nextProfile &&
            (profile.document_type !== nextProfile.document_type ||
                profile.passport_betrayed_name !== nextProfile.passport_betrayed_name ||
                profile.document_custom_betrayed_name !==
                    nextProfile.document_custom_betrayed_name),
    },
    {
        name: 'Код подразделения ',
        value: profile.document_type === 1 ? profile.passport_betrayed_code : '',
        blur:
            !!nextProfile && profile.passport_betrayed_code !== nextProfile.passport_betrayed_code,
    },
    {
        isDivider: true,
        noMargin: true,
    },
    {
        name: 'Организация',
        value: profile.company_name,
        blur: !!nextProfile && profile.company_name !== nextProfile.company_name,
        noMargin: true,
    },
    {
        name: 'ОГРНИП',
        value: profile.ogrn,
        blur: !!nextProfile && profile.ogrn !== nextProfile.ogrn,
    },
    {
        name: 'Наименование гос. органа, осуществившего регистрацию в ЕГРИП',
        value: profile.egrul_government_name,
        blur: !!nextProfile && profile.egrul_government_name !== nextProfile.egrul_government_name,
    },
    {
        name: 'Дата регистрации в ЕГРИП',
        value: profile.egrul_registration_date,
        blur:
            !!nextProfile &&
            profile.egrul_registration_date !== nextProfile.egrul_registration_date,
    },
    {
        name: 'Должность',
        value: profile.company_position,
        blur: !!nextProfile && profile.company_position !== nextProfile.company_position,
    },
    {
        isDivider: true,
        noMargin: true,
    },
    {
        name: 'ИНН организации',
        value: profile.personal_inn,
        blur: !!nextProfile && profile.personal_inn !== nextProfile.personal_inn,
    },
    {
        name: 'СНИЛС',
        value: profile.snils,
        blur: !!nextProfile && profile.snils !== nextProfile.snils,
    },
    {
        name: 'Телефон / факс',
        value: profile.company_phone || profile.phone,
        blur: !!nextProfile && profile.company_phone !== nextProfile.company_phone,
    },
    {
        name: 'Сайт',
        value: profile.web,
        blur: !!nextProfile && profile.web !== nextProfile.web,
    },
    {
        isDivider: true,
        noMargin: true,
    },
    {
        name: 'Банковские реквизиты',
        value: profile.bank_details,
        blur: !!nextProfile && profile.bank_details !== nextProfile.bank_details,
    }
]
